import React from "react";
import DropdownItem from "./DropdownItem";
import CustomScrollbars from './CustomScrollbars/CustomScrollbars';

export default class DropdownList extends React.Component {

    render() {
        let items = this.props.items.map((item,i) => <DropdownItem
            key={item[this.props.keyProp].toString()}
            name={item[this.props.valueProp]}
            is_default={false}
            onClick={() => this.props.onClick(item)}/>);

        const length = items.length;

        if (this.props.hasEmpty) {

            items.unshift(<DropdownItem
                key={"null"}
                name={this.props.emptyOptionName}
                onClick={() => this.props.onClick(null)}
            />);
        }

        if (length > 5) {

            items = (<CustomScrollbars style={{ width: "100%", height: 150 }} document={this.props.document}>
                {items}
            </CustomScrollbars>);
        }

        return (

                <div className="amt-widget-dropdown-list">
                    {length ? items : <div className="no-results">No results</div>}
                </div>
        );
    }
}
